import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';

@Component({
  selector: 'app-end-auction',
  templateUrl: './end-auction.component.html',
  styleUrls: ['./end-auction.component.css']
})
export class EndAuctionComponent implements OnInit {
  loading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EndAuctionComponent>,
    private _auctions: AuctionsService,
    public _config: ConfigService,
    public socket: SocketService,

  ) { }

  ngOnInit() {
  }
  endWithoutWinner() {
    this.loading = true;
    this._auctions.endAuctionWithoutWinner(this.data.auctionId).subscribe({
      next: (data: any) => {
        this._config.toastrService.success(data.message);
        // const auctionInfo = {
        //   auctionId: this.data.auctionId
        // }
        // this.socket.socket.emit("reloadPage", auctionInfo);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);
        this.dialogRef.close();

      }
    });
  }

  endWithWinner() {
    this.loading = true;
    this._auctions.endAuctionWithWinner(this.data.auctionId).subscribe({
      next: (data: any) => {
        this._config.toastrService.success(data.message);
        // const auctionInfo = {
        //   auctionId: this.data.auctionId
        // }
        // this.socket.socket.emit("reloadPage", auctionInfo);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        this.dialogRef.close();
        this._config.showErrors(error);
      }
    });
  }

}
